import React, { createContext, useContext, useCallback, useEffect, useRef, } from 'react';
const MenuItemProviderContext = createContext(() => []);
MenuItemProviderContext.displayName = 'MenuItemProviderContext';
export const MenuItemProviderProvider = (props) => {
    const refMenuItemProvider = useRef(props.menuItemProvider);
    useEffect(() => {
        refMenuItemProvider.current = props.menuItemProvider;
    }, [props.menuItemProvider]);
    // Use a stable function value to avoid invalidating the context
    const getMenuItems = useCallback((target) => {
        var _a, _b;
        return (_b = (_a = refMenuItemProvider.current) === null || _a === void 0 ? void 0 : _a.call(refMenuItemProvider, target)) !== null && _b !== void 0 ? _b : [];
    }, []);
    return (React.createElement(MenuItemProviderContext.Provider, { value: getMenuItems }, props.children));
};
/**
 * Get the latest menu item provider. The return value should only be called within a useEffect.
 */
export function useGetCustomMenuItems() {
    return useContext(MenuItemProviderContext);
}
